import { TexasPool } from "../../texas_pool";
import { TableHelp } from "../help/table_help";
import TexasSound from "../../texas_sound";
import { Define } from "../data/const_define";
import ModelData from "../../../../public/model_data";

//下注动画表现
const {ccclass, property} = cc._decorator;

interface BetData{
    type:number;
    count:number;
}

@ccclass
export class BetMoveEffect extends cc.Component {
    //bet 池
    private pool:TexasPool;

    private move:number = 4;//偏移值

    private handleArray = [];

    @property(cc.SpriteAtlas)
    spriteAtlasPoker: cc.SpriteAtlas = null

    @property(cc.Node)
    prefab:cc.Node = null;

    @property(cc.Node)
    startNode:cc.Node = null;

    @property(cc.Node)
    purposeNode:cc.Node = null;

    onLoad(){
        this.pool = new TexasPool(this.prefab);
        this.handleArray = [100000,50000,10000,5000,1000,500,200,100,50,1]//基础值
    }

    show(){
        this.node.active = true;
    }

    hide(){
        this.node.active = false;
        this.recycleAllBet();
    }

    //下注动画-------------------------------
    checkBet(gold:number,func?:Function){
        gold = TableHelp.getRightMount(gold);
        let betArray = this.getSortBet(gold);
        let y = 0;
        let maxCount = 0;
        let moveCount = 0;
        let tempLocaltion = this.startNode.parent.convertToWorldSpaceAR(this.startNode.position);
        let localPos = this.purposeNode.convertToNodeSpaceAR(tempLocaltion);
        this.node.stopAllActions();
        
        //筹码声音
        this.scheduleOnce(()=>{
            TexasSound.playBet();
            cc.log('-->>>>播放下注声音');
        },0.1)

        TableHelp.schedule(this.node,()=>{
            let data = betArray[maxCount];
            if (maxCount == betArray.length) {
                this.node.stopAllActions();
            }else{
                let node = this.pool.obtain();
                let name = this.getBetName(data.type);
                node.stopAllActions();
                node.getComponent(cc.Sprite).spriteFrame = this.getSpriteFrameByName(name);
                node.parent = this.purposeNode;
                node.active = true;
                node.position = localPos;

                let ease = cc.easeOut(4.5);
                let move = cc.moveTo(Define.checkMoveTime,cc.v2(0,y)).easing(ease);
                let call = cc.callFunc(()=>{
                    moveCount++;
                    if (moveCount == betArray.length) {//结束时显示
                        //回收原来的
                        this.recycleAllBet();
                        this.showBet(gold);
                    }
                });
                let seq = cc.sequence(move,call);
                node.runAction(seq);
                y+=this.move;
                maxCount++;
            }
        },Define.checkInterval);
    }

    //对应的边池移动到玩家
    obtainBet(target:cc.Node,endNode:cc.Node,gold:number,comp?:Function){
        this.recycleAllBet();
        gold = TableHelp.getRightMount(gold);
        let sworldPos = target.parent.convertToWorldSpaceAR(target.position);
        let slocalPos = this.purposeNode.convertToNodeSpaceAR(sworldPos);
        this._showBet(gold,slocalPos);
        //归池
        let children = this.purposeNode.children.concat([]);
        let maxCount = children.length-1;
        let recycleCount = children.length
        let eworldPos = endNode.parent.convertToWorldSpaceAR(endNode.position);
        let elocalPos = this.purposeNode.convertToNodeSpaceAR(eworldPos);

        this.scheduleOnce(()=>{
            TexasSound.playReceiveBet();
        },0.1)
        this.node.stopAllActions();
        TableHelp.schedule(this.node,()=>{
            if (maxCount == -1) {
                this.node.stopAllActions();
            }else{
                //移动动画
                let node = children[maxCount]
                if (node) {
                    node.stopAllActions();
                    let move = cc.moveTo(Define.obtainMoveTime,elocalPos)
                    let call = cc.callFunc(()=>{
                        node.active = false;
                        this.pool.recycle(node);//回收
                        if (recycleCount == 1) {
                            if (comp) {
                                comp();
                            }
                        }
                        recycleCount--;
                    })
                    let seq = cc.sequence(move,call);
                    node.runAction(seq);
                }
                maxCount--;
            }
        },Define.obtainInterval);

    }

    //归池动画 从下注 移动到池
    guiChi(target:cc.Node,func?:Function){
        //位置转换
        let tempLocaltion = target.parent.convertToWorldSpaceAR(target.position);
        //转换成相对small节点的坐标
        let localPos = this.purposeNode.convertToNodeSpaceAR(tempLocaltion);//目标位置

        //所有的归池
        let children = this.purposeNode.children.concat([]);
        let maxCount = children.length-1;
        //从大到小排序
        this.node.stopAllActions();
        if (children.length > 0) {
            TexasSound.playReceiveBet();
        }
        TableHelp.schedule(this.node,()=>{
            if (maxCount == -1) {
                this.node.stopAllActions();
            }else{
                //移动动画
                let node = children[maxCount]
                if (node) {
                    node.stopAllActions();
                    let move = cc.moveTo(Define.guiChiMoveTime,localPos)
                    let call = cc.callFunc(()=>{
                        node.active = false;
                        this.pool.recycle(node);//回收
                    })
                    let seq = cc.sequence(move,call);
                    node.runAction(seq);
                }
                maxCount--;
            }
        },Define.guiChiInterval);
    }

    //直接回收所有下注 每轮结束时执行清理
    recycleAllBet(){
        for (let bet of this.purposeNode.children.concat([])) {
            bet.active = false;
            this.pool.recycle(bet);
        }
    }
    //显示所下注金额
    showBet(gold:number){
        gold = TableHelp.getRightMount(gold);
        this._showBet(gold,cc.Vec2.ZERO)
    }

    private _showBet(gold:number,v:cc.Vec2){
        this.recycleAllBet();
        gold = TableHelp.getRightMount(gold);
        let betArray = this.getSortBet(gold);
        let y = 0;
        for (const data of betArray) {
            let node = this.pool.obtain();
            let name = this.getBetName(data.type);
            node.stopAllActions();
            node.getComponent(cc.Sprite).spriteFrame = this.getSpriteFrameByName(name);
            node.parent = this.purposeNode;
            node.active = true;
            node.position = cc.v2(v.x,y+v.y);
            y+=this.move;  
        }
    }

    private getSortBet(gold:number):BetData[]{
        let bet:Array<BetData> = [];
        this._handleBetNumb(gold,0,bet);
        bet.sort(function(a:BetData,b:BetData){
            return b.type - a.type;
        })
        let betArray = [];
        for (let bt of bet) {
            for (let i = 0; i < bt.count; i++) {
                betArray.push(bt);
            }
        }
        return betArray;
    }

    private getBetName(type:number){
        ////删除isMangoTable的判断  modif by dred 
        // if (ModelData.instance.tableCommonData.isMangoTable) {
        //     return 'mb';
        // }
        switch(type){
            case 0://10000
                return 'public_bet_10000';
            case 1://500
                return 'public_bet_5000';
            case 2://100
                return 'public_bet_1000';
            case 3://10
                return 'public_bet_500';
            case 4://5
                return 'public_bet_100';
            case 5://1
                return 'public_bet_50';
            case 6://1
                return 'public_bet_20';
            case 7://1
                return 'public_bet_10';
            case 8://1
                return 'public_bet_5';
            case 9://1
                return 'public_bet_1';
        }
    }

    //处理金币数量
    private _handleBetNumb(max:number,ct:number,arr:Array<BetData>){
        if (max < 1) {
            max = 1;//最小单元
        }
        let length = arr.length;
        let base = this.handleArray[length];
        if (base == null || base == 0 || max == 0) {//错误
            return;
        }
        let listNumb = 0;
        let cnt = 0;
        if (max >= base) {
            cnt = parseInt((max / base).toString());
            ct = ct + cnt ;
        }
        listNumb = max % base;
        if (ct > 7 || max <= 0) {
            let listCount = 7 - (ct - cnt);//可以放置剩余的数量
            arr.push({type:length,count:listCount});
            return
        }
        arr.push({type:length,count:cnt});
        this._handleBetNumb(listNumb,ct,arr);
    }

    protected getSpriteFrameByName(key: string){
        return this.spriteAtlasPoker.getSpriteFrame(key)
    }

    clear(){
        this.recycleAllBet();
        this.pool.clear();
    }
}
